import config from '../../config';
import { authHeader } from '../../helpers';

export async function fetchMembers() {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' }
  };

  return fetch(`${config.apiUrl}/members`, requestOptions).then(handleResponse);
}

export async function addMember(memberModel) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(memberModel)
  };

  return fetch(`${config.apiUrl}/members`, requestOptions).then(handleResponse);
}

export async function removeMember(memberId) {
  const requestOptions = {
    method: 'DELETE',
    headers: { ...authHeader(), 'Content-Type': 'application/json' }
  };

  return fetch(`${config.apiUrl}/members/${memberId}`, requestOptions).then(handleResponse);
}

export async function editMember(memberId, memberModel) {
  const requestOptions = {
    method: 'PUT',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(memberModel)
  };

  return fetch(`${config.apiUrl}/members/${memberId}`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        // logout();
        //location.reload(true);
      }

      const error = data && data.message || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}
